import styled from 'styled-components';
import { ColorAddiFontPrimary } from '@addi/foundation/dist/web/colors';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
import { SizeAddiFontSmall, SizeAddiFontXLarge } from '@addi/foundation/dist/web/sizes';
import { Header2 } from '../Typpographies.styled';
export const TitleCategory = styled(Header2) `
  margin: 8px 0 4px 0;
  line-height: 24.8px;
  display: flex;
  align-items: center;
  width: fit-content;
  font-size: ${SizeAddiFontSmall};
  color: ${ColorAddiFontPrimary};
  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    font-size: ${SizeAddiFontXLarge};
    line-height: 48.4px;
  }
`;
//# sourceMappingURL=title-main-category.styled.js.map